import { Home, Users, Settings, Archive } from "lucide-react";
import { ROUTES } from "../routes/Routes";

export const SidebarItems = [
  {
    label: "Home",
    icon: <Home />,
    to: ROUTES.HOME,
  },


  {
    label: "Customer Base",
    icon: <Users />,
    to: ROUTES.DPC,
  },
  {
    label: "Product Base",
    icon: <Archive />,
    to: ROUTES.PRODUCTS,
  },
  {
    label: "Settings",
    icon: <Settings />,
    to: ROUTES.SETTINGS,
  },
];
